var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartData)?_c('v-card',[_c('Pie',{attrs:{"id":"all-treinos-pie","options":_vm.chartOptions,"data":_vm.chartData}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }